{
  "shared": {
    "upload": {
      "dropHint": "Browse for a file or drop it here.",
      "limit": "Maximum file size: {{size}} MB.",
      "tooLarge": "Choose a file no larger than {{size}} MB. Your previous selection is kept.",
      "wrongType": "Choose one of the file types shown for this document. Your previous selection is kept.",
      "oneFile": "Choose one file at a time.",
      "selected": "Selected file",
      "remove": "Remove file",
      "sending": "Sending the file. Wait for the server result."
    }
  }
}
